import React, { FC } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { NegotiationActions } from 'api'
import { ModalConsumerProps, withModal, NotificationType } from 'view/shared/modal'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { CancelAllNegotiationsWrapper, CancelAllNegotiationsWarningsWrapper } from './toolbarStyles'
import { allCancellableNegotiationIdsSelector } from 'selectors/negotiations'
import { createIsInitiatedNegotiationCounterpartyViewEnabled } from 'selectors/userPreferenceSelectors'
import { Locale, Translation } from 'locale'

interface CancelAllNegotiationsButtonProps extends ModalConsumerProps {
  cancellableNegotiationIds: string[]
  isCounterpartyViewEnabled: boolean
  onCancelBulk: (negotiationIds: string[], cloneOriginalOrder: boolean) => unknown
}

const mapStateToProps = createStructuredSelector({
  cancellableNegotiationIds: allCancellableNegotiationIdsSelector,
  isCounterpartyViewEnabled: createIsInitiatedNegotiationCounterpartyViewEnabled()
})

const mapDispatchToProps = {
  onCancelBulk: NegotiationActions.cancelBulk
}

export const CancelAllNegotiationsButtonComponent: FC<CancelAllNegotiationsButtonProps> = props => {
  const { cancellableNegotiationIds, isCounterpartyViewEnabled, onCancelBulk, showDialog } = props
  const disabled = cancellableNegotiationIds.length === 0

  if (!isCounterpartyViewEnabled) {
    return null
  }

  const warningMessageComponent = (
    <CancelAllNegotiationsWarningsWrapper>
      <span>{Locale.translate(Translation.SC_CANCEL_ALL_RFQ_CONFIRMATION_1)}</span>
      <span>{Locale.translate(Translation.SC_CANCEL_ALL_RFQ_CONFIRMATION_2)}</span>
      <span>{Locale.translate(Translation.SC_CANCEL_ALL_RFQ_CONFIRMATION_3)}</span>
    </CancelAllNegotiationsWarningsWrapper>
  )

  const handleClick = async () => {
    const dialogArgs = {
      type: NotificationType.Confirm,
      title: Translation.TC_CANCEL_ALL_RFQ,
      messageComponent: warningMessageComponent,
      buttons: [Translation.TC_BUTTON_YES, Translation.SC_BUTTON_YES_AND_STAGE, Translation.TC_BUTTON_NO],
      cancelButton: Translation.TC_BUTTON_NO,
      defaultButton: Translation.TC_BUTTON_YES
    }
    const dialogResult = await showDialog(dialogArgs)

    if (dialogResult === Translation.TC_BUTTON_YES) {
      onCancelBulk(cancellableNegotiationIds, false)
    }

    if (dialogResult === Translation.SC_BUTTON_YES_AND_STAGE) {
      onCancelBulk(cancellableNegotiationIds, true)
    }
  }

  return (
    <CancelAllNegotiationsWrapper>
      <TextButton type={TextButtonType.BadLight} disabled={disabled} onClick={handleClick}>
        {Locale.translate(Translation.TC_ACTION_CANCEL_ALL)}
      </TextButton>
    </CancelAllNegotiationsWrapper>
  )
}

export const CancelAllNegotiationsButton = withModal(connect(mapStateToProps, mapDispatchToProps)(CancelAllNegotiationsButtonComponent))
